import { getTeacherDomain } from './getAppByDomain';
import { getHost } from './getHost';

export const isInTeacherDomain = () => getHost() === getTeacherDomain();
